import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=b91806c4&"
import script from "./CustomField.vue?vue&type=script&lang=ts&"
export * from "./CustomField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports